var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useEffect, useState } from "react";
import { StarList } from "./common/StarList";
import { showError, showSuccess, translate } from "@js/common/helpers";
import { GlobalModal } from "../../modals/GlobalModal";
import { collectionRatingApi } from "../api";
import { GlobalModalModes, Statuses } from "../enums";
var Rating = function (_a) {
    var initialData = _a.initialData, user = _a.user, afterRatingChange = _a.afterRatingChange;
    var _b = useState(false), isRatingOfConnectedUser = _b[0], setIsRatingOfConnectedUser = _b[1];
    var _c = useState(false), showGlobalModal = _c[0], setShowGlobalModal = _c[1];
    var _d = useState(), mode = _d[0], setMode = _d[1];
    useEffect(function () {
        var getIsRatingOfConnectedUser = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (user['logged'] === false) {
                    return [2];
                }
                if (user['uuid'] === undefined || initialData.userUuid === '') {
                    return [2];
                }
                if (user['uuid'] !== initialData.userUuid) {
                    return [2];
                }
                setIsRatingOfConnectedUser(true);
                return [2];
            });
        }); };
        getIsRatingOfConnectedUser();
    }, []);
    var onAction = function (currentMode, event) {
        event.stopPropagation();
        setShowGlobalModal(true);
        setMode(currentMode);
    };
    var handleAfterClose = function () {
        setShowGlobalModal(false);
    };
    var handleAfterRatingUpdate = function (ratingState) { return __awaiter(void 0, void 0, void 0, function () {
        var note, comment, status_1, updated, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    note = ratingState.note, comment = ratingState.comment, status_1 = ratingState.status;
                    return [4, collectionRatingApi.patch(initialData['id'], note, comment, status_1)];
                case 1:
                    updated = _b.sent();
                    if (!updated) {
                        showError('collection_rating.modal.global.edit.error.global');
                        return [2];
                    }
                    setShowGlobalModal(false);
                    if (typeof afterRatingChange === 'function') {
                        afterRatingChange();
                    }
                    showSuccess('collection_rating.modal.global.edit.success', undefined, true);
                    return [3, 3];
                case 2:
                    _a = _b.sent();
                    showError('collection_rating.modal.global.edit.error.global');
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleAfterRatingDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deleted, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, collectionRatingApi.remove(initialData['id'])];
                case 1:
                    deleted = _b.sent();
                    if (!deleted) {
                        showError('collection_rating.modal.global.delete.error.global');
                        return [2];
                    }
                    setShowGlobalModal(false);
                    if (typeof afterRatingChange === 'function') {
                        afterRatingChange();
                    }
                    localStorage.removeItem('rating');
                    localStorage.removeItem('comment');
                    showSuccess('collection_rating.modal.global.delete.success', undefined, true);
                    return [3, 3];
                case 2:
                    _a = _b.sent();
                    showError('collection_rating.modal.global.delete.error.global');
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "rating" },
            React.createElement(StarList, { note: initialData.note }),
            initialData.comment && (React.createElement("p", { className: "comment" }, initialData.comment)),
            (isRatingOfConnectedUser && initialData.comment === '') && (React.createElement("p", null, translate('collection_rating.list.your_comment'))),
            React.createElement("div", { className: "flex" },
                React.createElement("p", { className: "details" }, isRatingOfConnectedUser
                    ? (initialData.comment ? translate('collection_rating.list.your_comment') + (initialData.status === Statuses.Pending ? translate('collection_rating.list.waiting_approval') : '') : translate('collection_rating.list.your_rating'))
                    : initialData.userName),
                isRatingOfConnectedUser && (React.createElement(React.Fragment, null,
                    React.createElement("button", { className: "btn-link", onClick: function (event) { return onAction(GlobalModalModes.Edit, event); } }, translate('collection_rating.list.action.edit')),
                    React.createElement("button", { className: "btn-link", onClick: function (event) { return onAction(GlobalModalModes.Delete, event); } }, translate('collection_rating.list.action.delete')))),
                React.createElement("p", { className: "posted-at" }, initialData.postedAt))),
        showGlobalModal
            && React.createElement(GlobalModal, { mode: mode, rating: initialData, afterRatingUpdate: handleAfterRatingUpdate, afterRatingDelete: handleAfterRatingDelete, afterClose: handleAfterClose })));
};
export { Rating };
